export const TaskData_Array = "TaskData_Array";

export const CelebritiesVids_Data = "CelebritiesVids_Data";
export const Contact_Data = "Contact_Data";
export const Astro_Data = "Astro_Data";

export const InquiryAction_Data = "InquiryAction_Data";
export const InquiryAction_User = "InquiryAction_User";
export const Slider_Data = "Slider_Data";




export const SET_ADMIN_ID = 'SET_ADMIN_ID';
export const AdminSingle_Data = 'AdminSingle_Data';



export const BankDetails_Data = "BankDetails_Data";
export const BankDetailsSingle_Data = "BankDetailsSingle_Data";

export const SET_ASTRO_ID = 'SET_ASTRO_ID';
export const SET_Blog_ID = 'SET_Blog_ID';
export const SET__Puja_ID = 'SET__Puja_ID';
export const SET__Gemstone_ID = 'SET__Gemstone_ID';
export const SET__GemstoneOrderID = 'SET__GemstoneOrderID';


export const AstrologerSingle_Data = 'AstrologerSingle_Data';

export const QualificationDrp_Data = 'QualificationDrp_Data';
export const DregeeDiplomaDrp_Data = 'DregeeDiplomaDrp_Data';



export const setAstroId = (id) => {
    return {
        type: SET_ASTRO_ID,
        payload: id,
    };
};

export const setAdminId = (id) => {
    return {
        type: SET_ADMIN_ID,
        payload: id,
    };
};

export const setBlogID = (id) => {
    return {
        type: SET_Blog_ID,
        payload: id,
    };
};




export const Horo_Data = "Horo_Data";
export const HoroScopeName_Data = 'HoroScopeName_Data';
export const HoroScopeSingle_Data = 'HoroScopeSingle_Data';


export const SliderSingle_Data = 'SliderSingle_Data';



export const WalletSingle_Data = 'WalletSingle_Data';
export const Wallet_Data = "Wallet_Data";








export const SkillsList_Data = 'SkillsList_Data';
export const SkillsListSingle_Data = 'SkillsListSingle_Data';

export const LanguagesList_Data = 'LanguagesList_Data';
export const LanguagesListSingle_Data = 'LanguagesListSingle_Data';




export const BlogCategory_Data = 'BlogCategory_Data';
export const BlogCategorySingle_Data = 'BlogCategorySingle_Data';
export const Blog_Data = 'Blog_Data';
export const BlogSingle_Data = 'BlogSingle_Data';
export const BlogCategoryDrp_Data = 'BlogCategoryDrp_Data';

export const AuthorName = 'AuthorName';
export const AuthorNameSingle_Data = 'AuthorNameSingle_Data';


export const DregeeDiploma_Data = 'DregeeDiploma_Data';
export const DregeeDiplomaSingle_Data = 'DregeeDiplomaSingle_Data';


export const Skills_Data = 'Skills_Data';
export const Languages_Data = 'Languages_Data';
export const Categorys_Data="Categorys_Data";


export const AstrologersCategory_Data = 'AstrologersCategory_Data';
export const AstrologersCategorySingle_Data = 'AstrologersCategorySingle_Data';





export const PrivacyPolicy_Data = 'PrivacyPolicy_Data';
export const PrivacyPolicySingle_Data = 'PrivacyPolicySingle_Data';
export const PrivacyPolicyDrop_Data = 'PrivacyPolicyCategory_Data';




export const GetData_Muhurat = "GetData_Muhurat";
export const GetSinglaData_Muhurat = "GetSinglaData_Muhurat";
export const GetDropDwonData_Muhurat = 'GetDropDwonData_Muhurat';

export const GetData_MainMuhurat = "GetData_MainMuhurat";
export const GetSinglaData_MainMuhurat = "GetSinglaData_MainMuhurat";




export const CategoryRedirect="categoryRedirect";
export const CategoryCondition="CategoryCondition";
export const CategoryRedirectsingle="CategoryRedirectsingle";
export const CategoryNotification_Data = 'CategoryNotification_Data';
export const CategoryNotification_Single_Data = 'CategoryNotification_Single_Data';

export const DataNotification_Data = 'DataNotification_Data';

export const PushCategoryDrp_Data = 'PushCategoryDrp_Data';
export const PushCategory_Single_Data = 'PushCategory_Single_Data';
export const SET_DROPDOWN_DATA = 'SET_DROPDOWN_DATA';
export const SET_DROPDOWN_ASTRO = 'SET_DROPDOWN_ASTRO';

export const Pooja_Data = 'Pooja_Data';
export const Pooja_Single_Data = 'Pooja_Single_Data';

export const Puja_Get_Data_Puja = 'Puja_Get_Data_Puja';
export const PujaFor_GetDropDownData_PujaFor = 'PujaFor_GetDropDownData_PujaFor';
export const Puja_GetSinglaData_Puja = 'Puja_GetSinglaData_Puja';

export const Gemstone_Category_data = 'Gemstone_Category_data';
export const GemstoneCategory_Singledata = 'GemstoneCategory_Singledata';

export const Gemstone_GetData_GemData = 'Gemstone_GetData_GemData';
export const GemstoneCategory_GetDropDawnData = 'GemstoneCategory_GetDropDawnData';
export const Gemstone_Singledata = 'Gemstone_Singledata';
export const Gemstone_User = 'Gemstone_User';
export const Gemstone_Cart_List = 'Gemstone_Cart_List';
export const SinglaData_GemstoneOrder = 'SinglaData_GemstoneOrder';


export const CAll_CHART_DATA = "Call_chart_data";
export const Call_History = 'Call_History';
export const Home_Page_Count = 'Home_Page_Count';
export const Chat_Acc_Day = 'Chat_Acc_Day';
export const Astro_Filter = 'Astro_Filter';
export const User_Filter = 'User_Filter';


export const Expense_Category = 'Expense_Category';
export const Single_Expense_Category = 'Single_Expense_Category';
export const Insert_ExpenseCategory = "Insert_ExpenseCategory";
export const Update_ExpenseCategory = "Update_ExpenseCategory";
export const Delete_ExpenseCategory = "Delete_ExpenseCategory"

export const Expense_Details = "Expense_Details";
export const Single_Expense_Details = "Single_Expense_Details";
export const Insert_Expense_Details = "Insert_Expense_Details";
export const Update_Expense_Details = "Update_Expense_Details";
export const Delete_Expense_Details = "Delete_Expense_Details";
export const GetDropDownData_ExpenseCategory = "GetDropDownData_ExpenseCategory";


export const GetData_TransactionCategory = 'GetData_TransactionCategory';
export const GetSingleData_TransactionCategory = 'GetSingleData_TransactionCategory';
export const GetDropDownData_TransactionCategory = "GetDropDownData_TransactionCategory";




export const GetData_CompanyTransaction = 'GetData_CompanyTransaction';
export const GetSingleData_CompanyTransaction = 'GetSingleData_CompanyTransaction';
export const GetData_headerCompanyTransaction = "GetData_headerCompanyTransaction"

export const GetData_PaymentHistory = 'GetData_PaymentHistory';
export const GetData_UserWalletTransaction = 'GetData_UserWalletTransaction';
export const GetData_AstroWalletTransaction = 'GetData_AstroWalletTransaction';
export const GetData_AstroSallaryTransaction = 'GetData_AstroSalaryTransaction';

export const GetsinglaData_Company = "GetsinglaData_Company";
export const GetData_Company = "GetData_Company";


export const Chat_Message = "Chat_Message";


export const Chat_Filter = 'Chat_Filter';
export const Online_Puja_Filter = 'Online_Puja_Filter';
export const Gemstone_Filter = 'Gemstone_Filter';

export const Call_Filter = 'Call_Filter';
export const User_Status = 'User_Status';
export const Total_Astrologer = "Total_Astrologer";
export const Chat_Chart = "Chat_Chart";
export const Gemstone_Revenue = "Gemstone_Revenue";
export const Pooja_Revenue = "Pooja_Revenue";
export const Call_Revenue = "Call_Revenue";

export const User_list = "User_list";
export const SinglaData_User = "SinglaData_User";

export const User_Insert = "User_Insert";
export const GetData_Users = "GetData_Users";







export const Income_Category = 'Income_Category';
export const SinglaData_IncomeCategory = 'SinglaData_IncomeCategory';
export const Ticket_Category = 'Ticket_Category';
export const SinglaData_Ticket_Category = 'SinglaData_Ticket_Category';











export const GetData_VratUpvaas = "GetData_VratUpvaas";
export const GetSinglaData_VratUpvaas = "GetSinglaData_VratUpvaas";
export const GetDropDwonData_VratUpvaas = 'GetDropDwonData_VratUpvaas';



export const GetData_MainVratUpvaas = "GetData_MainVratUpvaas";
export const GetSinglaData_MainVratUpvaas = "GetSinglaData_MainVratUpvaas";
export const GetDropDwonData_MainVratUpvaas = 'GetDropDwonData_MainVratUpvaas';

export const GetData_Paymentbutnotbuy = 'GetData_Paymentbutnotbuy';
export const GetData_PaymentchangeRequest = "GetData_PaymentchangeRequest";
export const GetData_AstrologerGallery = "GetData_AstrologerGallery";
export const GetSinglaData_AstrologerGallery = "GetSinglaData_AstrologerGallery";
export const GetData_Feedback = "GetData_Feedback";
export const GetSingleData_Feedback = "GetSingleData_Feedback";
export const GetData_UserNotUsed = "GetData_UserNotUsed";
export const GetSinglaData_PaymentchangeRequest = "GetSinglaData_PaymentchangeRequest";
export const GetData_Festival = "GetData_Festival";
export const GetSinglaData_Festival = "GetSinglaData_Festival";

export const GetData_NotificationRule = "GetData_NotificationRule";
export const GetSinglaData_NotificationRule = "GetSinglaData_NotificationRule"

export const GetData_PackageRoles = "GetData_PackageRoles";
export const GetSinglaData_PackageRoles = "GetSinglaData_PackageRoles"

export const GetData_Expense = "GetData_Expense";
export const GetSinglaData_Expense = "GetSinglaData_Expense"
export const GetData_ChatAnalysisReport = "GetData_ChatAnalysisReport";
export  const GetData_WalletPlanName="GetData_WalletPlanName";
export const GetsinglaData_WalletPlanName="GetsinglaData_WalletPlanName";
